import { useState, useEffect } from "react";
import { useAuth } from "../../App";
import SDRLayout from "../../components/sdr/SDRLayout";
import { Card, CardContent } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { CalendarDays, Loader2 } from "lucide-react";

const SDRLeaderboard = () => {
  const { API, token, user } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${API}/sdr/leaderboard`, { headers: { Authorization: `Bearer ${token}` } });
        if (r.ok) setData(await r.json());
      } catch (err) { console.error("Failed to load leaderboard:", err);
        console.error("Request failed:", err);
      }
      setLoading(false);
    })();
  }, [API, token]);

  if (loading) return <SDRLayout><div className="flex items-center justify-center h-64"><Loader2 className="w-8 h-8 animate-spin text-gray-400" /></div></SDRLayout>;

  const myCode = user?.agent_code;
  const rankBg = ["bg-yellow-50 border-yellow-200", "bg-gray-50 border-gray-200", "bg-amber-50 border-amber-200"];
  const rankColors = ["text-yellow-500", "text-gray-400", "text-amber-700"];

  return (
    <SDRLayout>
      <div className="space-y-6" data-testid="sdr-leaderboard">
        <div>
          <h1 className="text-2xl font-bold text-[#1A2636]">Leaderboard</h1>
          <p className="text-sm text-gray-500 mt-1">Ranked by total appointments set</p>
        </div>
        <Card className="border-0 shadow-sm max-w-2xl">
          <CardContent className="p-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-sky-500 to-blue-600 flex items-center justify-center">
                <CalendarDays className="w-5 h-5 text-white" />
              </div>
              <div>
                <h2 className="font-bold text-[#1A2636]">Appointments Set</h2>
                <p className="text-xs text-gray-500">All-time rankings</p>
              </div>
            </div>
            {data.length ? (
              <div className="space-y-2">
                {data.map((entry, i) => {
                  const isMe = entry.agent_code === myCode;
                  return (
                    <div
                      key={entry.agent_code}
                      className={`flex items-center justify-between p-3 rounded-lg border transition-colors ${
                        i < 3 ? rankBg[i] : "bg-white border-gray-100"
                      } ${isMe ? "ring-2 ring-sky-400 ring-offset-1" : ""}`}
                    >
                      <div className="flex items-center gap-3">
                        <span className={`text-lg font-bold w-8 text-center ${i < 3 ? rankColors[i] : "text-gray-400"}`}>{i + 1}</span>
                        <div>
                          <span className="text-sm font-semibold text-[#1A2636]">
                            {entry.name}
                            {isMe && <Badge className="ml-2 bg-sky-100 text-sky-700 text-[10px]">You</Badge>}
                          </span>
                          <p className="text-[11px] text-gray-400 font-mono">{entry.agent_code}</p>
                        </div>
                      </div>
                      <p className="text-base font-bold text-[#1A2636]">{entry.appointments} appts</p>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="text-sm text-gray-400 text-center py-6">No data yet</p>
            )}
          </CardContent>
        </Card>
      </div>
    </SDRLayout>
  );
};

export default SDRLeaderboard;
